import * as React from 'react'
import { observer } from 'mobx-react'

import { Section, SectionItem } from '../../components/Section'
import PersonalProfileViewModel from '../PersonalProfile/PersonalProfileViewModel'
import { PhysicalAddressSectionItems } from 'jobs/info-gathering/components/PhysicalAddress'
import { ContactInfoSectionItems } from 'jobs/info-gathering/components/ContactInfo'

interface Props {
  vm: PersonalProfileViewModel
}

export default observer(function PersonalProfile({ vm }: Props) {
  if (!vm.profile) {
    return <></>
  }

  return (
    <div>
      <Section title="Personal Information" loading={vm.activate.pending}>
        <SectionItem label="Name" value={vm.profile?.personalInfo?.fullName} />

        <SectionItem
          label="Date of birth"
          value={vm.profile?.personalInfo?.dateOfBirth}
          isSensitive
        />

        <SectionItem
          label="Occupation"
          value={vm.profile?.occupation}
          isSensitive
        />

        <SectionItem
          label="SSN or ITIN"
          value={vm.profile?.personalInfo?.personalTaxpayerIdentificationNumber}
          maskedValue={
            vm.profile?.personalInfo
              ?.personalTaxpayerIdentificationNumberDisplay
          }
          isSensitive
        />
      </Section>

      <Section
        title="Contact Information"
        loading={vm.activate.pending}
        bordered
      >
        <ContactInfoSectionItems vm={vm.profile?.contactInfo} />
        <PhysicalAddressSectionItems vm={vm.profile?.contactInfo} />
      </Section>
    </div>
  )
})
